<template>
  <Header v-if="!isAgeGate" />

  <AgeGate v-if="isAgeGate" />
  <router-view v-else v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
  
  
</template>

<script>
import AgeGate from '@/components/AgeGate.vue'

import Header from '@/components/Header.vue'

import resize from '@/utils/resize'
import scroll from '@/utils/scroll'
import bowserToClasses from '@/utils/bowserToClasses'
import smoothscroll from 'smoothscroll-polyfill'
import scrollama from '@/controllers/scrollama'
import scrollshow from '@/controllers/scrollshow'


export default {
  name: 'App',
  components: {
    Header,
    AgeGate
  },
  data () {
    return {
      isAgeGate: this.$route.params.ageGate,
    }
  },
  mounted() {
    smoothscroll.polyfill();
    window.__forceSmoothScrollPolyfill__ = true;

    bowserToClasses()
    resize.init()
    scroll.init()
  },
   watch:{
    $route (to, from){
      this.isAgeGate = this.$route.params.ageGate
    }
  } 
}
</script>
